import styled from "styled-components";
import { responsive } from "../../styles/constants.style";

export const ProgramSearchWrapper = styled.div`
  .MuiGrid2-root {
    ${responsive.MOBILE`
      padding-right: 0px;
    `}
  }
`;
